<template>


  <div class="">
    <v-row v-if="game"  class=" ma-0" style="background-color:black">
<!--      <v-col cols="6" class="text-center">-->
<!--        <h5 class="body-2">-->
<!--          <span class="text-uppercase font-weight-bold">BETTING</span>-->
<!--        </h5>-->
<!--      </v-col>-->
<!--      <v-col cols="6">-->
<!--        <h5 class="body-2 text-center font-weight-bold">-->
<!--          <span v-if="showFightNum">FIGHT #</span>-->
<!--        </h5>-->
<!--      </v-col>-->

      <v-col cols="6" class="text-center" >
        <v-btn
          :color="statusCss"
          elevation="2"
          small
          class="rounded"
        >
          <span class="font-weight-bold subtitle-2">{{ statusLabel }}</span>
        </v-btn>
      </v-col>

      <v-col cols="6">
        <h5 class="body-1 text-center font-weight-bold">
          <span v-if="showFightNum">#{{ game.game_num }}</span>
        </h5>
      </v-col>

    </v-row>
  </div>

</template>
<script>
export default {
  props: ["game", "statusLabel", "loading"],
  computed: {
    statusCss() {

      if(this.game.status == 1)
        return "#2eb85c !important";

      if(this.game.status == 4)
        return "green";

      if(this.game.status == 4 || this.game.status == 6 || this.game.status == 3 || this.game.status == 5)
        return "red";

      if(this.game.status == 2 || this.game.status == 0)
        return "red";

      return "red";

    },
    statusWrapperCss() {
      return {
        animated: this.game.status == 2,
        flash: this.game.status == 2,
        infinite: this.game.status == 2,
      };
    },
    showFightNum() {
      return this.game && this.game.game_num;
    },
  },
};
</script>

<style lang="sass" scoped>
.game-header
  font-weight: 300

.game-status
  font-size: .9em
  text-align: right
  margin-top: .11em
  .circle
    margin-top: .1em
    margin-bottom: -.1em

.logo-text-top
    font-style: italic
    font-size: 20px
    font-weight: 600
.logo-text-bot
    font-size: 13px
    font-style: italic
    margin-left: -4px
    line-height: 0


.button-slanted
  -ms-transform: skewX(-15deg)
  -webkit-transform: skewX(-15deg)
  transform: skewX(-15deg)
  background-color: #192036
  padding:0 10px


.button-slanted-content
  -ms-transform: skewX(15deg)
  -webkit-transform: skewX(15deg)
  transform: skewX(15deg)
  display: inline-block
</style>



<style>
  
.mb-0 {
    margin-bottom: 0!important;
}

.table-bordered, .table-bordered>tbody>tr>td, .table-bordered>tbody>tr>th, .table-bordered>tfoot>tr>td, .table-bordered>tfoot>tr>th, .table-bordered>thead>tr>td, .table-bordered>thead>tr>th {
    border: 1px solid hsla(0,0%,100%,.05);
}
.table {
    width: 100%;
    max-width: 100%;
    color: #9a9da2;
}
.text-center {
    text-align: center!important;
}
.mb-0, .my-0 {
    margin-bottom: 0!important;
}
.table-bordered, .table-bordered td, .table-bordered th {
    border: 1px solid #dee2e6;
}
.table {
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
}
table {
    background-color: transparent;
    color: #9a9da2;
}
table {
    border-collapse: collapse;
}
*, :after, :before {
    box-sizing: border-box;
}
user agent stylesheet
table {
    display: table;
    border-collapse: separate;
    box-sizing: border-box;
    text-indent: initial;
    border-spacing: 2px;
    border-color: grey;
}

thead {
    display: table-header-group;
    vertical-align: middle;
    border-color: inherit;
}

*, :after, :before {
    box-sizing: border-box;
}
user agent stylesheet
tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
}

#betting-dashboard .beting-status-label {
    font-size: 15px !important;
}
#betting-dashboard .label {
    font-size: 10px !important;
}
.label-success {
    background-color: #2eb85c !important;
}
.label-success {
    background-color: #24d9b0;
}
.label, a.label:focus, a.label:hover {
    color: #fff;
}
.label {
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .25em;
    padding: .5em 1.1em;
    font-size: 8px;
    font-family: Montserrat,sans-serif;
    text-transform: uppercase;
}
.pb-1, .py-1 {
    padding-bottom: .25rem!important;
}
.pt-1, .py-1 {
    padding-top: .25rem!important;
}
*, :after, :before {
    box-sizing: border-box;
}
</style>